
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.91 11.62C20.91 16.51 17.36 21.09 12.51 22.43C12.18 22.52 11.82 22.52 11.49 22.43C6.63999 21.09 3.09 16.51 3.09 11.62V7.22997C3.09 6.40997 3.71001 5.47998 4.48001 5.16998L10.05 2.89001C11.3 2.38001 12.71 2.38001 13.96 2.89001L19.53 5.16998C20.29 5.47998 20.92 6.40997 20.92 7.22997L20.91 11.62Z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z","stroke":"currentColor","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 13V16","stroke":"currentColor","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    